import { render, staticRenderFns } from "./analyse-inairrealtimedata.vue?vue&type=template&id=72f6881e&scoped=true&"
import script from "./analyse-inairrealtimedata.vue?vue&type=script&lang=ts&"
export * from "./analyse-inairrealtimedata.vue?vue&type=script&lang=ts&"
import style0 from "./analyse-inairrealtimedata.vue?vue&type=style&index=0&id=72f6881e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f6881e",
  null
  
)

export default component.exports